'use client';

import { useAppSelector } from '@/lib/hooks';
import type { Account } from '@/types';

const useAccountData = (): Account => useAppSelector((state) => state.account);

export default useAccountData;
